// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bruteforcesettings-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-Ly0obkwS_mjs":"f28264b9a8279247b597","vendors-node_modules_rehype-highlight_index_js":"a0d1c632413cd555c833","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CSmrMOEO_mjs":"d866d189c2931e245174"}[chunkId] + "";
};